import { createSlice } from '@reduxjs/toolkit'
import { sendAudioCommandm } from '../actions/audio.action'
import { Audio } from '@dataTypes/index'

export type AudioState = {
  data: Audio | null
  loading: boolean
  error: null
}

const initialState: AudioState = {
  data: null,
  loading: false,
  error: null,
}

export const audioSlice = createSlice({
  name: 'audios',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendAudioCommandm.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(sendAudioCommandm.pending, (state) => {
      state.loading = true
    })
    builder.addCase(sendAudioCommandm.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default audioSlice.reducer
